import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { BodyBackgroundService } from './services/body-background.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  
  title = 'IQ Water System';

  constructor(
    private router : Router, 
    private route : ActivatedRoute,
    private titleService : Title,
    private backgroundService : BodyBackgroundService) {  }
  
  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.route))
      .pipe(map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }))
      .pipe(filter(route => route.outlet === 'primary'))
      .pipe(mergeMap(route => route.data))
      .subscribe(event => this.handleRouteData(event));
  }

  handleRouteData(data : any) {
    if (!data) return;
    var title = data.title ? this.title + ' - ' + data.title : this.title;
    this.titleService.setTitle(title);
    this.backgroundService.setBackground(data.background);
  }

  
}
